import {createSelector, MemoizedSelector,} from '@ngrx/store';
import {rolesArcgisAdapter, RolesArcgisState} from './roles-arcgis.state';

import {FeaturesState, selectFeatures} from '../../../features.state';
import {RoleArcgis} from '../../../../../core';

export const getError = (state: RolesArcgisState): any => state.error;

export const getIsLoading = (state: RolesArcgisState): boolean => state.isLoading;

export const selectRolesArcgisState = createSelector(selectFeatures,
  (state: FeaturesState) => state.rolesArcgis
);

export const selectAllRolesArcgis: (state: object) => RoleArcgis[] = rolesArcgisAdapter.getSelectors(
  selectRolesArcgisState
).selectAll;

export const selectRoleArcgisById = (id: string) =>
  createSelector(
    selectAllRolesArcgis,
    (allRoles: RoleArcgis[]) => {
      if (allRoles) {
        return allRoles.find(p => p.id === id);
      } else {
        return null;
      }
    }
  );

export const selectRolesArcgisIsLoading: MemoizedSelector<object, boolean> = createSelector(
  selectRolesArcgisState,
  getIsLoading
);

